<template>
  <div class="">
    <div class="head-title">批量添加好友</div>
    <el-collapse style="margin-bottom: 2rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业可将收集到的所有客户手机号批量导入生成群发任务，设置分配员工后系统将任务推送给该员工，进行运营转化。
          </p>
          <p>
            2、员工根据系统推送手机号进行批量添加好友任务，系统自动获取添加状态。
            <a class="help-link" href="https://www.weijub.com/index/index/news_detail?id=125" target="_blank"
              rel="noopener noreferrer">使用教程</a>
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button icon="el-icon-s-promotion" @click="tianjia()" type="primary">导入Excel</el-button>
        </div>
        <div class="nav-r">
          <el-input clearable style="width: 27rem; " placeholder="请输入xls名称搜索"
            prefix-icon="el-icon-search" v-model="input2" @change="rune()">
          </el-input>
          <el-button slot="append" @click="rune()" type="primary">查询</el-button>
        </div>
      </nav>
      <div style="margin-top: 2rem">
        <el-table :data="tableData.data" border
          @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column prop="account" label="管理员账户" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="phone" label="手机号" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="name" label="xls名称" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="createtime" label="时间" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="user_name" label="分配员工" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="label" label="标签" style="width: 14.28%;">
            <template slot-scope="scope">
              <el-popover placement="left" trigger="hover">
                <template>
                  <div class="set-popper" v-html="scope.row.label"></div>
                </template>
                <div slot="reference">
                  <div v-if="scope.row.label == '暂无'">
                    <el-tag size="mini">{{ scope.row.label }}</el-tag>
                  </div>
                  <div v-else class="set-content">
                    <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.label" :key="index">{{ i
                    }}</el-tag>
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="导入总数" style="width: 14.28%;"></el-table-column>
          <el-table-column prop="add_count" label="已添加人数" style="width: 14.28%;"></el-table-column>

          <el-table-column label="操作" fixed="right" width="300" >
            <template slot-scope="scope">
              <el-button @click="tixing(scope.row)" size="mini" type="text">提醒</el-button>
              <el-button @click="particulars(scope.row)" size="mini" type="text">详情</el-button>
              <el-button @click="dele(scope.row.id)" style="color:#f00000 !important;" size="mini" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging">
        <pagination
        :total="tableData.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        :auto-scroll="false"
        @pagination="userTable" />
      </div>
    </div>

    <el-dialog title="上传表格" center  :visible.sync="onSubmit" :before-close="handleClose" width="60%">
      <el-form ref="form" :inline="true"  :model="form" :rules="rules" label-width="12rem">
        <div class="nav_tabel"></div>
        <div class="leib">
          <span>请下载模板后输入手机号上传，可批量复制手机号至模板内，若输入内容有重复手机号或空行将会自动过滤</span>
          <div class="download">
          <a style="color: #1890ff" href="https://api.weijub.com/tmp/客户列表.xls">下载Excel模板</a>
        </div>
        </div>
        <el-form-item label="选择表格" prop="xlsName" style="margin-top: 3rem;margin-right:17.9rem">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/home/uploads/uploads?usertoken=` +
            this.tooken.usertoken +
            '&account_id=' +
            this.tooken.account_id"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            accept=".xls">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传xls文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="选择员工" prop="peoName" style="margin-top: 3rem;margin-right:18.5rem">
          <el-button @click="onAdd" type="primary">选择员工</el-button>
          <div v-if="yuanname"><el-tag v-for="item of yuanname" :key="item" effect="plain" >{{ item }}</el-tag></div>
        </el-form-item>

        <el-form-item label="客户标签" prop="tagName"  style="margin-top: 3rem">
          <el-button @click="biaoq" type="primary">选择标签</el-button>
          <div v-if="biaoname">
            <el-tag effect="plain"  style="margin-right: 1.2rem" v-for="(item, index) in biaoname" :key="index">{{
            item }}</el-tag>
            </div>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择员工" center   :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8rem">
        <el-radio-group v-model="radio1">
          <el-radio :label="item" v-for="(item, index) in yuangong" :key="index">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="(onSubmitn = false), numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择标签" center :visible.sync="onSubmitnss" width="30%">
      <el-form ref="form" :model="form" label-width="8rem">
        <el-checkbox-group style="margin: 1.6rem 1.2rem" v-model="checkList" v-for="(item, index) in listdata" :key="index">
          <el-checkbox :label="item.group_name" disabled></el-checkbox>
          <br />
          <el-checkbox-group v-model="checkList" v-for="(oppen, index) in item.child" :key="index"
            style="display: inline-block; margin: 1rem">
            <el-checkbox :label="oppen">{{ oppen.tag_name }}</el-checkbox>
          </el-checkbox-group>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitnss = false">取 消</el-button>
        <el-button type="primary" @click="(onSubmitnss = false), labelid()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="错误信息"  center :visible.sync="onSubmitss" width="50%">
      <!--<div class="abude">
        <div v-for="item in value4.data" :key="item">{{ item }}</div>
      </div>--->
      <div class="abude">
        <el-table id="educe-table" :cell-style="columnStyle" tooltip-effect="dark"
        style="width: 100%" :data="value4.data"
          border>
          <el-table-column prop="remark_mobiles" label="重复手机号">
          </el-table-column>
          <el-table-column prop="createtime" label="导入时间"> </el-table-column>
          <el-table-column prop="account" label="操作人">
          </el-table-column>
          <el-table-column prop="phone" label="操作手机号"> </el-table-column>
        </el-table>
      </div>
      <!--<pagination
        :total="totalList"
        :page.sync="listQueryList.page"
        :limit.sync="listQueryList.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getList"
      />--->

      <span slot="footer" class="dialog-footer">

        <el-button @click="onSubmitss = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitss = false">确 定</el-button>
        <el-button type="primary" @click="exportExcel">导 出</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
export default {
  inject: ["reload"],
  name: "monitoring",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      onSubmitnss: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        xlsName: "",
        peoName: "",
        tagName: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      baseURL: this.axios.defaults.baseURL,
      fileList: [],
      url: "",
      imgs: [],
      tooken: {},
      yuangong: [],
      radio1: "",
      yuanname: [],
      biaoname: [],
      listdata: [],
      checkList: [],
      group_label: "",
      page: 1,
      loading: true,
      onSubmitss: false,
      value4: [],
      pageSize: "1",
      listQuery: {
        page: 1,
        limit: 20,
      },
      module: "",
      person: {},
      btnLoading: false,
      checkbox: false,
      userid: "",
      filePathName: "", //上传成功后的文件名
      rules: {
        xlsName: [
          { required: true, message: "请至少选择一个成员", trigger: "blur" },
        ],
        peoName: [
          { required: true, message: "请至少选择一个成员", trigger: "blur" },
        ],
      },
      taskId: 0
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    onAdd() {
      this.module = "getAddressBook";
      this.checkbox = false;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getWelcomeOne":
          this.userid = person.userid;
          this.yuanname = String(user);
          break;
        case "getAddressBook":
          // const userid = [];
          // const user = [];
          // person.map((item) => {
          //   userid.push(item.userid);
          //   user.push(item.name);
          // });
          this.userid = person.userid;
          this.yuanname = [person.name];
          // this.yuanname = user;
          console.log(this.yuanname);
          console.log(this.userid);
          break;
        default:
          break;
      }
    },
    /*导入Excel 弹窗关闭*/
    handleClose(){
      this.userid=''
      this.yuanname=""
      this.fileList = []
      this.onSubmit=false
    },
    particulars(e) {
      this.$router.replace({
        path: "/register/user/customerPhoneadd",
        query: {
          list: e,
        },
      });
    },
    tixing(e) {
      this.axios
        .post(
          "/crm/CircleFriends/remindUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: e.userid,
            id: e.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    labelid() {
      this.group_label = JSON.stringify(this.checkList);
      for (var i = 0; i < this.checkList.length; i++) {
        this.biaoname.push(this.checkList[i].tag_name);
      }
    },
    biaoq() {
      this.biaoname = [];
      this.checkList = [];
      this.axios
        .post(
          "/crm/Assistant/getLabelListUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.onSubmitnss = true;
          this.listdata = res.data.data;
        })
        .catch(function (err) { });
    },
    xuanzhe() {
      this.axios
        .post(
          "/crm/KpiSet/getKpiUserss",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            page: this.pageSize,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.onSubmitn = true;
          this.yuangong = res.data.data.data;
        })
        .catch(function (err) { });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    copyUrl(e) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute(
        "value",
        `${location.origin}/#/circle?account_id=${this.tooken.account_id}&userid=${e}`
      );
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    },
    //  页数
    handleCurrentChange() {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/CircleFriends/getCustomerPhoneTast",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.input2,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const isTagEmpty = i.label.includes("暂无");
            i.isTagEmpty = isTagEmpty;
            if (!isTagEmpty) {
              i.label = i.label.split(",");
            }
          });
          this.loading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.userTable();
    },
    tianjia() {
      this.onSubmit = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    bianji(e) {
      this.ele = e;
      this.$router.replace({
        path: "/register/user/circleFriendadd",
        query: {
          userid: e,
          account_id: this.tooken.account_id,
        },
      });
    },
    // 修改
    numoon() {
      this.yuanname = this.radio1.name;
    },

    // 添加
    numoo() {
      this.btnLoading = true;
      this.loading = true;
      this.aaaon();
    },
    aaaon() {
      this.axios
        .post(
          "/crm/CircleFriends/importCustomerPhone",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            // account_id: this.tooken.account_id,
            file_path: this.url,
            account_id: this.tooken.account_id,
            userid: this.userid,
            group_label: this.group_label,
            page: this.page,
            filePathName: this.filePathName,
            phone: this.tooken.phone,
            task_id: this.taskId
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            // 导入正在进行中，需要进行分页
            this.taskId = res.data.data.task_id;
            this.page = this.page * 1 + 1;
            this.aaaon();
          } else if (res.data.code == 2) {
            // 导入结束
            this.fileList = []
            this.btnLoading = false;
            this.loading = false;
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.url = "";
            // this.userTable();
            this.reload();
            return;
          } else if (res.data.code == 3) {
            // 导入结束， 有错误信息
            this.fileList = []
            this.onSubmit = false;
            this.btnLoading = false;
            this.loading = false;
            this.onSubmitss = true;
            this.value4 = res.data;

            this.userTable();
          } else if (res.data.code == 0) {
            this.btnLoading = false;
            this.loading = false;
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch(function (err) { });
    },
    dele(e) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CircleFriends/delCustomerPhoneList",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                // account_id: this.tooken.account_id,
                ids: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },
    handleSuccess(response, file, fileList) {
      console.log(file);
      if (response.code == 0) {
        this.$message.error(response.msg);
        file.status = "fail";
      } else {
        this.$message.success(response.msg);
        let arr = [];
        fileList.map((i) => {
          arr.push(i.response.data);
        });
        this.url = arr.toString();
        this.filePathName = file.name;
      }
    },
    handleError(err, fileList) {
      console.log(err);
      console.log(fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //table 首列变红
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'color:	red;'
      }
    },
    //导出
    exportExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector('#educe-table'))
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
          // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
          new Blob([wbout], { type: 'appliction/octet-stream' }),
          // 设置导出的文件名称可随意
          '重复数据列表.xls'
        )
      } catch (e) {
        if (typeof console != 'undefined') console.log(e, wbout)
      }
      // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
      return wbout
    }

  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: 0 .1rem .6rem 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 .1rem .6rem 0 rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

nav {
  width: 100%;
}

.shij {
  display: inline-block;
  margin-right: 2.4rem;
}

.bule {
  width: 80%;
  margin: 0 auto;
}



.nav_tabel {
  text-align: center;
}

.abude {
  color: rgb(238, 39, 39);
  font-size: 1.8rem;
  font-weight: 500;
  height: 20rem;
  overflow: hidden;
  overflow-y: auto;
}

.abude>div {
  padding: .5rem;
}
.el-button--text{
  padding-left:0 !important;
}
.leib {
    padding: 19px 2rem;
    font-size: 1.6rem;
    background: #FEF7EC;
    border-radius: .4rem;
    font-weight: 400;
    color: #FF9E58;
    line-height: 1.8rem;
    display: flex;
    justify-content: space-between;
}
.download{
    display: inline-block;
    background: #F6FBFF;
    border-radius: .8rem;
    border: .1rem solid #317AF8;
    padding: 1rem .6rem 1rem 1.2rem;
}
.el-form--inline .el-form-item{
  margin-right: 0;
}
</style>
